module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_winter-6f116d2fd44d8afd46a7bab6143f759e.jpg";